export enum USER_ROLES {
	ADMIN = "JF_ADMIN",
	JF_STAFF = "JF_STAFF",
	COMPANY_ADMIN = "COMPANY_ADMIN",
	COMPANY_USER = "COMPANY_USER"
}
